"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addNewItemToStore = exports.getStoredData = void 0;
var __constants__1 = require("./__constants__");
exports.getStoredData = function () {
    try {
        var data = JSON.parse(localStorage.getItem(__constants__1.constants.STORAGE_DATA_KEY));
        return data;
    }
    catch (error) {
        throw error;
    }
};
exports.addNewItemToStore = function (_a) {
    var _b;
    var key = _a.key, value = _a.value;
    if (__constants__1.paramTypes.includes(key)) {
        localStorage.setItem(__constants__1.constants.STORAGE_DATA_KEY, JSON.stringify(__assign(__assign({}, exports.getStoredData()), (_b = {}, _b[key] = value, _b))));
    }
    else {
        throw Error('item is not in accepted values');
    }
};
//# sourceMappingURL=store.js.map